<div
  [ngStyle]="{ display: _paymentService.numbermodule === 0 ? 'block' : 'none' }"
  class="container"
  [class.dark-mode]="isDarkMode"
  style="height: auto"
  >
  <form (ngSubmit)="sendFormCP()" action="" [formGroup]="formPayment">
    <div class="container mt-2">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="" class="form-label"><b>{{ getLabel('cardNumber') }}</b> </label>
            <div id="cardNumber" class="form-control" #cardNumber></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="" class="form-label"><b>{{ getLabel('expiration') }}</b></label>
            <input
              formControlName="expirationDate"
              [(ngModel)]="cardInfoExpire"
              (keyup)="dateFormat(expirationDate)"
              (input)="DateValidator(); justNumbersDate($event)"
              #expirationDate
              type="text"
              maxlength="5"
              minlength="5"
              name=""
              id=""
              [placeholder]="getLabel('placeholder.expiration')"
              class="form-control"
              required
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="" class="form-label"><b>{{ getLabel('cvv') }}</b></label>
              <div class="input-group-append">
                <div id="cardSC" class="form-control input-group"></div>
                <div
                  class="input-group-append align-items-center justify-content-center pl-2"
                  >
                  <button
                    type="button"
                    class="btn btn-secondary tip"
                    data-toggle="tooltip"
                    data-html="true"
                    title='<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAAA4CAYAAABjXd/gAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAWoSURBVHhe7Zz7U1RlHIf7Q7KL6WRWNk6XqXRyzMqapshJHUVuGTHBDMalxCSDVlhF3PHCNBWXYGkyMaQQC0wrLuLCLpcVYV3kJrjBIq67sFyWvfBp35d3WfYCLHB+qDnvM/OZOe+7e2bOPPuec97z5bw8AI6gcKECM6fQqakpdHV1Qd2sRmNjI48zTU1NaGtrg9lsZpZ88RFqs9lQdqEM0R9HIzo6Goe+OISUL1N4WJL2JyF4dzCyTmdBp9Mxa248hBKZUqmUStRoNKyX443JZELR2SKEh4XTs3g2HkJPnTyF9LR0KpazMIprCoSFhmFoaIj1zBKq1+sRsicEFouF9XACITcnF3K5nLVmCS2UFyIvL4+1OIHS39+P0JBQ2O122p4RKk2XQqFQsBZnMUSER8BgMNDtGaGpKal0asBZPFEfRWFgYIBuc6ECQISSU58wIzTo3SCeZYQLFThcqMDhQgUOFypwuFCBw4UKHC5U4HChAocLFThcqMDhQgUOFypwfISKtdo03tMNQ9XfuPfnFZgaVLCPjrJPAsdvtUlMQkdutODmp/G4+syTqHz0Qc+sXIGGt7finx/ksI+NsT3mR7RCrSYjNPGxVNzV9U+hI/UQBi/8CrNGg7HODhjrFbiTmw317h30O7XPr8fQ5T/Y3nMjSqHjt3ug2PACqtesQl/Od3BYJtgn/hnV3kTTjm1UbNexI6zXP6ITOqHT4dpLz9GMdtxivQsz5XCg62g6ldp9/Bjr9UVUQskrRc27tqP22XV0lC6FznQJlXr/ag3r8UQQof6mDv+1EPrPnqEy7pb/TttLYcpmQ8M7b0Gx8UW67Y2ohCrfeJWO0OVCblj0h/mtjPW4EY3QYXUzk3CRHbXzTn+rFJkHE5CUr4bV2XaYWvHL6SOQnvgJqrsOOO4pUZCSgPiDWbjSR77hRrl1C1o+CGUtN6IRqivIo0JtwyZ21E5GDeitOIighEuYgB3anDikVhhgrEhFbHYLWrNjcKBUD2N5AoKSqzHJdiN0HE6l0y1vRCNUe+Az1L3yMjtiN9Z6CbZRoU4cdjicYvt/PoCkczrnFmDub0PVqUjs/badjmIX+pLz9AeyDEzLcyEaoW2xMfRm4o2HUCf2gQqk7c/GdfrUacdA7Y+QfRKO+HM9VLAL8nhKhJKHgNmIRujNxDgoX9/MjtiNh1BrF4o+T0Khlrx1aEXHRTku99phv5WFnVHnMPtdZXItJkLH+3pZzzSiEdr7dRaqVj/i81TkFmpHX1EcgvYkQHrkKDLPKHH7ymGEhsUhMSIYief7PEZotywT1U+swhR7086FaITer6mmI8qouMaOOkCs4zBPOljDDZl+NW1/j7XciEaow2qlBQ5yLV0u5LpJfhwyc/BGNEIJPSdlqFz1MEZab9D2UmmNiULN02tg87MCRBCh/xdITbNu0wao3nwt4PqmN3o2XSI1Un+ISijBpFKi6vGVaN75/qKlDl0qpze2lr1htNDiD9EJJRgq/6JS6zdvpH/qWAgyM6BVppUrcD00eN76qSiFEkauq+m8lJy+6pBdGCwrxYTuDvt0WqKpsQHdxzNoua/ysYdocdkxOfsB1BfRCiU4LBbo5Pmo37KJiiWpXrsaNevWUoGkTUayJn4fzG2tbK/5EbVQF+R6SKr3+pJi9JyQ0VHZl/0NLSLbhofZtwLDr1Cygo4vq1kadFnNPa9lNfICOQryC1iLEyiuFYiu5ZwzQsmQJSvCJhe4AHM8yf8+n8bFjFCC7LgMGRkZM8vsOPOjUqno4tnBwUHW4yXU6nz2lUgkkHwlQWdnJ+vleEP+AUFJSQmV2d7eznqn8RBKIFKLi4sR+WEk9sXuo4LT0tJ4WJKTk+k/IJDJZOjt9ayLEnyEuiCnvVarhVKpRF1dHY8z9XX1UKvVMBqNzJIvcwrlLA0uVFCAfwE1U20ZWcjlRgAAAABJRU5ErkJggg==" alt="Tooltip Image" />'
                    >
                    <i class="lni lni-help"></i>
                  </button>
                </div>
              </div>

              <div></div>
            </div>
          </div>
        </div>
        @if (channel !== 6) {
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="" class="form-label"
                  ><b>{{ getLabel('email') }}</b></label
                  >
                  <input
                    [readonly]="uploadcard || _paymentService.isPayerEmailReadonly"
                    formControlName="emailAddress"
                    type="email"
                    name=""
                    id=""
                    [placeholder]="getLabel('placeholder.email')"
                    class="form-control"
                    [value]="emailForDom"
                    />
                  @if (formPayment.controls['emailAddress'].hasError('pattern')) {
                    <div
                      class="invalid-feedback"
                      style="display: block"
                      >
                      {{ getLabel('errors.emailPattern') }}
                    </div>
                  }
                  @if (
                    formPayment.controls['emailAddress'].hasError('domainTooLong')
                    ) {
                    <div
                      class="invalid-feedback"
                      style="display: block"
                      >
                      {{ getLabel('errors.domainTooLong') }}
                    </div>
                  }
                  @if (
                    formPayment.controls['emailAddress'].hasError(
                    'subdomainTooLong'
                    )
                    ) {
                    <div
                      class="invalid-feedback"
                      style="display: block"
                      >
                      {{ getLabel('errors.subdomainTooLong') }}
                    </div>
                  }
                  @if (formPayment.controls['emailAddress'].errors?.['required'] && formPayment.controls['emailAddress']?.touched) {
                    <small
                      class="text-danger"
                      >{{ getLabel('errors.required') }}</small
                      >
                  }
                </div>
              </div>
            </div>
          }
          <div class="row mt-2">
            <div class="col-12">
              <div class="form-check">
                <mat-checkbox
                  class="form-check-input"
                  formControlName="aceptarterminos"
                  >
                  @if (channel === 7) {
                    <div>
                      <label class="mt-3 text-checks"
                        >Acepto
                        <a class="classtyc" (click)="tyc()"
                          >Términos y condiciones</a
                          >
                          </label
                          >
                          / <label class="mt-3 text-checks"
                          >I accept
                          <a class="classtyc" (click)="tyc()"
                            >Terms and Conditions</a
                            >
                            </label
                            >
                          </div>
                        }
                        @if (channel !== 7) {
                          <div>
                            <label class="mt-3 text-checks"
                              >Acepto los
                              <a class="classtyc" (click)="tyc()"
                                >Términos y condiciones</a
                                >
                                </label
                                >
                              </div>
                            }
                          </mat-checkbox>
                          <!-- <input type="checkbox" class="form-check-input" id="termsConditions"> -->
                          <!-- <label class="form-check-label" for="termsConditions">Acepto términos y condiciones</label> -->
                        </div>
                      </div>
                    </div>
                    @if (canEnrAutPay == 'true') {
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check example-section">
                            <mat-checkbox
                              class="form-check-input"
                              formControlName="afiliartarjeta"
                              (click)="linkDebitValidator($event)"
                              [disabled]="onlyLinkAutomaticDebit"
                              >
                              <div>
                                <label class="mt-3 text-checks">
                                  Afiliar mi tarjeta al Débito Automático Mensual
                                </label>
                              </div>
                            </mat-checkbox>
                            <!-- <input type="checkbox" class="form-check-input" id="saveCard">
                            <!-- <label class="form-check-label" for="saveCard">Afiliar mi tarjeta al Débito Automático Mensual</label> -->
                          </div>
                        </div>
                      </div>
                    }
                    @if (canRegCard == 'true') {
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <mat-checkbox
                              id="saveCard"
                              formControlName="isLinked"
                              class="form-check-input"
                              >
                              <div>
                                <label for="" class="mt-3 text-checks">
                                  Recordar los datos de mi tarjeta
                                </label>
                              </div>
                            </mat-checkbox>
                          </div>
                        </div>
                      </div>
                    }
                    <div class="row justify-content-center align-items-center">
                      <div class="row">&nbsp;</div>
                    </div>
                    <div class="row">
                      <div class="col-1"></div>
                      <div class="col-10 text-center">
                        <div class="form-group">
                          <button
                            [disabled]="formPayment.invalid"
                            [ngClass]="buttonClass"
                            class="btn btn-primary btnPrimary"
                            >
                            {{ getLabel('continue') }}
                          </button>
                        </div>
                      </div>
                      <div class="col-1"></div>
                    </div>
                  </div>
                </form>
              </div>
              <iframe title="centinel" id="cardinal_collection_iframe" name="collectionIframe" height="10" width="10"
              style="display: none" #iframe></iframe>
              <form #cardinalForm id="cardinal_collection_form" method="POST" target="collectionIframe"
                [attr.action]="cardinalAction">
                <input id="cardinal_collection_form_input" type="hidden" name="JWT" [attr.value]="jwtCardinal" />
                <div
                  class="modal fade dark-mode"
                  id="modalIframeAuth"
                  tabindex="-1"
                  aria-labelledby="modalIframeAuth"
                  aria-hidden="true"
                  data-backdrop="static"
                  >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header p-0 m-0">
                        <div class="modal-body p-0 m-0">
                          <div id="main-iframe-container" class="m-0 p-0">
                            <div id="div-autentications" class="container w-100 m-0 p-0"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <app-continue-page
                  [ngStyle]="{ display: _paymentService.numbermodule === 1 ? 'block' : 'none' }"
                ></app-continue-page>
                <app-tyc
                  [ngStyle]="{ display: _paymentService.tyc === true ? 'block' : 'none' }"
                ></app-tyc>
                <router-outlet name="payment"></router-outlet>
